export const prepareCustomerArea = (customerId: number, areaId: number): MutationBody => ({
  data: {
    type: 'CustomersAreas',
    attributes: {},
    relationships: {
      customer: {
        data: { id: `/api/v2/customers/${customerId}`, type: 'Customer' }
      },

      area: {
        data: {
          id: `/api/v2/areas/${areaId}`,
          type: 'Area'
        }
      }
    }
  }
});
